import { FEATURES, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export const checkPermission = ({ user, show }) => {
  if (!user || !show) return false
  if (show[FEATURES.CONTROLADORIA_V2]) return true
  return !!user.IS_INTERNAL && !!show[FEATURES.CONTROLADORIA_V2_LIMITED_AAWZ]
}

export default [
  {
    path: '/controladoria',
    name: 'controladoria-v2',
    redirect: '/controladoria/fechamentos',
    meta: {
      customPermission: checkPermission,
      search: {
        title: 'Controladoria',
        description: 'Fechamentos contábeis e DRE do escritório',
        keywords: [
          'controladoria',
          'fechamento',
          'dre',
          'contábil',
          'financeiro',
        ],
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () =>
      lazyLoadView(
        import(
          '@modules/controladoria-v2/views/nav-bar/controladoria-v2-nav-bar.vue'
        )
      ),
    children: [
      {
        path: 'fechamentos',
        name: 'controladoria-v2.fechamentos',
        meta: {
          permission: ['gestor'],
          customPermission: checkPermission,
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/controladoria-v2/views/view-fechamentos/view-fechamentos.vue'
            )
          ),
      },
      {
        path: 'acoes-em-lote',
        name: 'controladoria-v2.acoes-em-lote',
        meta: {
          permission: ['gestor'],
          customPermission: checkPermission,
          search: {
            title: 'Ações em Lote',
            description: 'Ações em lote nos fechamentos da controladoria',
            keywords: ['ações em lote', 'controladoria', 'fechamentos', 'lote'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/controladoria-v2/views/view-acoes-em-lote/view-acoes-em-lote.vue'
            )
          ),
      },
      {
        path: 'fechamento/:mes/:ano',
        name: 'controladoria-v2.fechamento',
        redirect: (to) => ({
          name: 'controladoria-v2.fechamento.dre',
          params: to.params,
        }),
        meta: {
          permission: ['gestor'],
          customPermission: checkPermission,
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/controladoria-v2/views/view-fechamento/view-fechamento.vue'
            )
          ),
        children: [
          {
            path: 'dre',
            name: 'controladoria-v2.fechamento.dre',
            redirect: (to) => ({
              name: 'controladoria-v2.fechamento.dre.type',
              params: { ...to.params, type: 'geral' },
            }),
            meta: {
              permission: ['gestor'],
              customPermission: checkPermission,
            },
            component: () =>
              lazyLoadView(
                import(
                  '@modules/controladoria-v2/views/view-dre-do-mes/view-dre-do-mes.vue'
                )
              ),
            children: [
              {
                path: ':type',
                name: 'controladoria-v2.fechamento.dre.type',
                meta: {
                  permission: ['gestor'],
                  customPermission: checkPermission,
                },
                component: () =>
                  lazyLoadView(
                    import(
                      '@modules/controladoria-v2/views/view-dre-do-mes/view-dre-do-mes-tab.vue'
                    )
                  ),
              },
            ],
          },
          {
            path: 'importacao',
            name: 'controladoria-v2.fechamento.importacao',
            meta: {
              permission: ['gestor'],
              customPermission: checkPermission,
            },
            component: () =>
              lazyLoadView(
                import(
                  '@modules/controladoria-v2/views/view-importacao-dados/view-importacao-dados.vue'
                )
              ),
          },
          {
            path: 'config',
            name: 'controladoria-v2.fechamento.config',
            redirect: (to) => ({
              name: 'controladoria-v2.fechamento.config.tab',
              params: { ...to.params, configTab: 'cat_lanc' },
            }),
            meta: {
              permission: ['gestor'],
              customPermission: checkPermission,
            },
            component: () =>
              lazyLoadView(
                import(
                  '@modules/controladoria-v2/views/view-configuracao-dre/view-configuracao-dre.vue'
                )
              ),
            children: [
              {
                path: ':configTab',
                name: 'controladoria-v2.fechamento.config.tab',
                meta: {
                  permission: ['gestor'],
                  customPermission: checkPermission,
                },
              },
            ],
          },
        ],
      },
    ],
  },
]
